export default __webpack_public_path__ + "static/media/chat-2.2efbcb41.svg";